import * as types from "./types";

export function actionSelectedDate(payload) {
  return {
    type: types.SELECTED_DATE,
    value: payload
  };
}

export function functionSelectedDate(selectedDate) {
  return dispatch => {
    dispatch(
      actionSelectedDate({
        selectedDate
      })
    );
  };
}

export function actionSelectedHours(payload) {
  return {
    type: types.SELECTED_HOURS,
    value: payload
  };
}

export function functionSelectedHours(selectedHours) {
  return dispatch => {
    dispatch(
      actionSelectedHours({
        selectedHours
      })
    );
  };
}
